import { render, staticRenderFns } from "./HolidaysParticipantsPrintList.vue?vue&type=template&id=19b6f0fd&scoped=true&"
import script from "./HolidaysParticipantsPrintList.vue?vue&type=script&lang=ts&"
export * from "./HolidaysParticipantsPrintList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6f0fd",
  null
  
)

export default component.exports